import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CheckMilimetragemService {
  private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getChecksMilimetragem(ordem = null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/checkmilimetragem' + (ordem ? '/ordem/' + ordem : ''))
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getCheckMilimetragem(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/checkmilimetragem/' + id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getCheckMilimetragemByUnidade(unidade_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/checkmilimetragem/unidade/' + unidade_id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getCheckMilimetragemByUsuario(usuario_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/checkmilimetragem/usuario/' + usuario_id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getCheckMilimetragemByRegiao(usuario_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/checkmilimetragem/regiao/' + usuario_id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	criaCheckMilimetragem(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/checkmilimetragem', {
        usuario_id:  data.usuario_id,
        check_milimetragem_data:  data.check_milimetragem_data,
        check_milimetragem_turno:  data.check_milimetragem_turno,
        cliente_id:  data.cliente_id,
        unidade_id:  data.unidade_id,
        profissional_id:  data.profissional_id,
        veiculo_id:  data.veiculo_id,
        check_milimetragem_ed_s1: data.check_milimetragem_ed_s1,
        check_milimetragem_ed_s2: data.check_milimetragem_ed_s2,
        check_milimetragem_ed_s3: data.check_milimetragem_ed_s3,
        check_milimetragem_ed_s4: data.check_milimetragem_ed_s4,
        check_milimetragem_et_s1: data.check_milimetragem_et_s1,
        check_milimetragem_et_s2: data.check_milimetragem_et_s2,
        check_milimetragem_et_s3: data.check_milimetragem_et_s3,
        check_milimetragem_et_s4: data.check_milimetragem_et_s4,
        check_milimetragem_dd_s1: data.check_milimetragem_dd_s1,
        check_milimetragem_dd_s2: data.check_milimetragem_dd_s2,
        check_milimetragem_dd_s3: data.check_milimetragem_dd_s3,
        check_milimetragem_dd_s4: data.check_milimetragem_dd_s4,
        check_milimetragem_dt_s1: data.check_milimetragem_dt_s1,
        check_milimetragem_dt_s2: data.check_milimetragem_dt_s2,
        check_milimetragem_dt_s3: data.check_milimetragem_dt_s3,
        check_milimetragem_dt_s4: data.check_milimetragem_dt_s4,
        check_milimetragem_registro: data.check_milimetragem_registro
			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	editaCheckMilimetragem(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/checkmilimetragem/' + data.check_milimetragem_id, {
				check_milimetragem_id:  data.check_milimetragem_id,
        usuario_id:  data.usuario_id,
        check_milimetragem_data:  data.check_milimetragem_data,
        check_milimetragem_turno:  data.check_milimetragem_turno,
        cliente_id:  data.cliente_id,
        unidade_id:  data.unidade_id,
        profissional_id:  data.profissional_id,
        veiculo_id:  data.veiculo_id,
        check_milimetragem_ed_s1: data.check_milimetragem_ed_s1,
        check_milimetragem_ed_s2: data.check_milimetragem_ed_s2,
        check_milimetragem_ed_s3: data.check_milimetragem_ed_s3,
        check_milimetragem_ed_s4: data.check_milimetragem_ed_s4,
        check_milimetragem_et_s1: data.check_milimetragem_et_s1,
        check_milimetragem_et_s2: data.check_milimetragem_et_s2,
        check_milimetragem_et_s3: data.check_milimetragem_et_s3,
        check_milimetragem_et_s4: data.check_milimetragem_et_s4,
        check_milimetragem_dd_s1: data.check_milimetragem_dd_s1,
        check_milimetragem_dd_s2: data.check_milimetragem_dd_s2,
        check_milimetragem_dd_s3: data.check_milimetragem_dd_s3,
        check_milimetragem_dd_s4: data.check_milimetragem_dd_s4,
        check_milimetragem_dt_s1: data.check_milimetragem_dt_s1,
        check_milimetragem_dt_s2: data.check_milimetragem_dt_s2,
        check_milimetragem_dt_s3: data.check_milimetragem_dt_s3,
        check_milimetragem_dt_s4: data.check_milimetragem_dt_s4,
        check_milimetragem_registro: data.check_milimetragem_registro

			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	apagaCheckMilimetragem(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/checkmilimetragem/' + id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	apagaCheckMilimetragemAdmin(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/checkmilimetragem/admin/' + id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}
}

